import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

export const CustomerEsimQr = ({ esim }) => {
  const [src, setSrc] = useState("");
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    let objectUrl;
    setSrc(""); setError(false);
    api.get(esim.qr_url.replace(/^\/api/, ""), { responseType: "blob" }).then(({ data }) => {
      if (!active) return;
      objectUrl = URL.createObjectURL(data);
      setSrc(objectUrl);
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [esim.qr_url, attempt]);
  return <div className="space-y-3" data-testid={`private-esim-${esim.id}`}>
    {src ? <>
      <img src={src} alt="QR di installazione eSIM" width={160} height={160} className="rounded-lg bg-white p-2" data-testid={`esim-qr-${esim.id}`} />
      <a href={src} download={`esim-${esim.id}.png`} className="inline-flex gap-1 items-center text-sm text-primary" data-testid={`esim-download-${esim.id}`}><Download className="w-4 h-4" /> Scarica QR</a>
    </> : error ? <div role="alert" data-testid={`esim-qr-error-${esim.id}`}>
      <p className="text-sm">QR non disponibile al momento.</p>
      <Button size="sm" variant="outline" onClick={() => setAttempt((n) => n + 1)} data-testid={`esim-qr-retry-${esim.id}`}>Riprova</Button>
    </div> : <p className="text-sm text-muted-foreground" data-testid={`esim-qr-loading-${esim.id}`}>Caricamento QR…</p>}
  </div>;
};
